module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('RPPDropdown', {
    attrs: {
      "value": _vm.rows,
      "options": _vm.rowsOptions,
      "optionLabel": "label",
      "optionValue": "value"
    },
    on: {
      "input": function($event) {
        return _vm.onChange($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ab3ca44"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/paginator/RowsPerPageDropdown.vue
// module id = 2251
// module chunks = 0